var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimplified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30264 3C7.68347 3 8.04869 3.15128 8.31798 3.42056L9.33331 4.4359H19.3846C19.7811 4.4359 20.1025 4.75733 20.1025 5.15385V16.8205C20.1025 16.9196 20.0222 17 19.9231 17H0.179464C0.0803363 17 -2.28882e-05 16.9196 -2.28882e-05 16.8205V3.71795C-2.28882e-05 3.32144 0.321414 3 0.717926 3L7.30264 3Z",
    fill: "#ECC65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30264 5.8718C7.68347 5.8718 8.04869 5.72051 8.31798 5.45123L9.33331 4.4359H19.3846C19.7811 4.4359 20.1025 4.75733 20.1025 5.15385L20.1025 16.8205C20.1025 16.9196 20.0222 17 19.9231 17H0.179465C0.080337 17 -2.21729e-05 16.9196 -2.21729e-05 16.8205V5.8718H7.30264Z",
    fill: "#FFE18F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30264 5.8718C7.68347 5.8718 8.04869 5.72051 8.31798 5.45123L9.33331 4.4359H19.3846C19.7811 4.4359 20.1025 4.75733 20.1025 5.15385L20.1025 16.8205C20.1025 16.9196 20.0222 17 19.9231 17H0.179465C0.080337 17 -2.21729e-05 16.9196 -2.21729e-05 16.8205V5.8718H7.30264Z",
    fill: "#FFE18F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.3027 5.8718C7.68353 5.8718 8.04875 5.72051 8.31804 5.45123L9.33337 4.4359H9.6026L8.46035 5.57815C8.15741 5.88109 7.74653 6.05128 7.3181 6.05128H3.73647e-05V5.8718H7.3027Z",
    fill: "#FFE18F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplified);
export default __webpack_public_path__ + "static/media/simplified.a5fcca8f6df2722e7d9fa5aceda0df8b.svg";
export { ForwardRef as ReactComponent };